export default __webpack_public_path__ + "static/media/categories.acbe843e.svg";